<template>
  <Modal id="modal-coupons" v-slot="{ close }">
    <ModalShell size="md" :title="$t('apply_coupon')" :close="close">
      <div>
        <!-- Input Coupon -->
        <StoreCoupon>
          <template #default="{ couponErrors }">
            <div class="p-4">
              <div class="flex items-center">
                <FormField class="flex-grow me-2" :show-error="false">
                  <FormTextbox
                    v-model="manualCode"
                    name="manual code"
                    rules="required"
                    :placeholder="$t('enter_coupon_code')"
                    @keyup="handleKeyup"
                  />
                </FormField>

                <VyButton
                  theme="solid"
                  color="primary"
                  shape="rounded"
                  size="md"
                  :label="$t('apply')"
                  @click="applyCoupon(manualCode)"
                />
              </div>
              <Error
                class="px-4 py-2 mt-1 text-xs border rounded-md text-danger-600 pe-6 bg-danger-50 border-danger-200"
                :errors="couponErrors"
              />
            </div>
          </template>
        </StoreCoupon>
        <!-- List All Coupons -->
        <Query ref="query" :query="couponsGQL" :variables="variables">
          <template #loading>
            <div class="p-4">
              <ShimmerCoupons />
            </div>
          </template>

          <template
            #default="{
              data: {
                cartDiscountCouponCodes: { data },
              },
            }"
          >
            <template v-if="data.length">
              <div class="p-4">
                <p class="text-xs tracking-wide text-gray-500 uppercase">
                  {{ $t("available_coupon") }}
                </p>
                <div class="mt-2 space-y-3">
                  <StoreCoupon
                    v-for="coupon in data"
                    :id="coupon.id"
                    :key="coupon.id"
                    :code="coupon.code"
                    :discount-type="coupon.discountType"
                    :discount-value="coupon.discountValue"
                    :minimum-order-value="coupon.minimumOrderValue"
                    :is-applicable="coupon.isApplicable"
                    :desc="coupon.description"
                  />
                </div>
              </div>
            </template>
          </template>
        </Query>
      </div>
    </ModalShell>
  </Modal>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useVepaarStore } from "@/store/store.js";
import { useCartStore } from "@/store/cart.js";
import coupons from "@/graph/store/coupons.gql";
export default {
  data() {
    return {
      manualCode: null,
      couponsGQL: coupons,
    };
  },

  computed: {
    ...mapState(useVepaarStore, ["hash"]),
    ...mapState(useCartStore, ["cart", "couponErrors", "sessionId"]),

    variables() {
      return {
        hash: this.hash,
        cartId: this.sessionId,
      };
    },
  },

  methods: {
    ...mapActions(useCartStore, ["upsertCart"]),

    applyCoupon(code) {
      this.upsertCart({ couponCode: code }).then(() => {
        if (!this.couponErrors.length) {
          this.manualCode = null;
          this.$nuxt.callHook("modal-close", "modal-coupons");
        }
      });
    },

    handleKeyup(event) {
      // Prevent specific keys from triggering the apply function
      const allowedKeys = ["Enter", "NumpadEnter"];
      if (allowedKeys.includes(event.key)) {
        return; // Allow these keys to proceed
      }
      // Prevent the default action for other keys
      event.preventDefault();
      event.stopPropagation();
    },
  },
};
</script>
